import { Body, Box, BoxProps, Divider, Heading, Link } from '@hover/blueprint';
import { AnchorLink } from 'gatsby-plugin-anchor-links';
import React, { useState } from 'react';
import { DownloadAppModal } from '../../../common';
import ArrowButton from '../../../ui/ArrowButton';
import BasicFeaturesMobile from './BasicsFeaturesMobile';
import BasicsFeaturesTabletAndDesktop from './BasicsFeaturesTabletAndDesktop';

interface Props extends BoxProps {}

const Basics: React.FC<Props> = props => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const toggleModal = () => setIsOpen(!isOpen);
  return (
    <Box
      mt={{ base: 500, tablet: 0 }}
      w={{ base: '100%', tablet: '353px', desktop: '380px' }}
      position="relative"
      borderRadius="8px"
      shadow="distance300"
      flexDir="column"
      overflow="hidden"
      {...props}
    >
      <DownloadAppModal isOpen={isOpen} onClose={toggleModal} />
      <Box position="absolute" top={0} bg="brandBrown.500" h={50} w="100%" />
      <Box
        pt={700}
        px={{ base: '38px', tablet: '28px', desktop: 700 }}
        w="100%"
        flexDir="column"
        alignItems="center"
        bg="brandBrown.100"
      >
        <Heading
          size={{ base: 500, tablet: 600 }}
          marginBottom={{ base: 400, tablet: 500 }}
        >
          Basics
        </Heading>
        <Body
          textAlign="center"
          size={{ base: 500, tablet: 600 }}
          marginBottom={{ base: 500, tablet: 600 }}
        >
          Measurement reports, design, and ordering, only when you need them
        </Body>
        <ArrowButton
          onClick={toggleModal}
          mb={{ base: 400, tablet: 600 }}
          w={{ base: '100%', tablet: '230px' }}
        >
          Get started now
        </ArrowButton>
      </Box>
      <Box
        px={{ base: 700, tablet: '45px', desktop: '57px' }}
        flexDir="column"
        bg={{ base: 'brandBrown.100', tablet: 'neutral.0' }}
      >
        <Body
          mt={{ base: 0, tablet: 600 }}
          textAlign="center"
          size={{ base: 500, tablet: 600 }}
          isSemiBold
        >
          <Link
            as={AnchorLink}
            stripHash
            to={`${process.env.GATSBY_V2_PREFIX}/pricing#pricing-to-match-each-property`}
          >
            Standard property rates
          </Link>
          , with no commitment
        </Body>
      </Box>
      <Box
        pt={{ base: 400, tablet: 500 }}
        bg={{ base: 'brandBrown.100', tablet: 'neutral.0' }}
        px={400}
        pb={{ base: 400, tablet: 500 }}
      >
        <Divider borderColor={{ base: 'neutral.0', tablet: 'neutral.300' }} />
      </Box>
      <BasicFeaturesMobile />
      <BasicsFeaturesTabletAndDesktop />
    </Box>
  );
};

export default Basics;
